import { CheckBox } from '@interstate/components/CheckBox';
import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';
import type { DealTabs } from '@makemydeal/dr-shared-types';

import FieldOverrideIndicator from './FieldOverrideIndicator.interstate';
import { useAcquisitionFeeField } from './hooks/useAcquisitionFeeField';

const AcquisitionFeeAmountField = ({ tab }: { tab?: DealTabs }) => {
    const { label, upfrontLabel, overrideIndicatorProps, inputProps, upfrontProps } = useAcquisitionFeeField({ tab });

    return (
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: '0.857rem' }} className={'base-deal-lease-field'}>
            <FieldOverrideIndicator {...overrideIndicatorProps} reserveSpace={false} overlayIcon={true}>
                <NumericInput {...inputProps} label={label} />
            </FieldOverrideIndicator>
            <CheckBox {...upfrontProps} label={upfrontLabel} sx={{ marginBottom: 0, backgroundColor: 'transparent' }} />
        </div>
    );
};

export default AcquisitionFeeAmountField;
